import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'table-configuration-sso',
    templateUrl: './configuration-sso.component.html',
    styleUrls: ['./configuration-sso.component.scss'],
})
export class TableConfigurationSSOComponent implements OnInit {

    @Input('data') config;

    constructor() { }

    ngOnInit() { }
    // Método para alternar a visibilidade do Client ID no SSO
    toggleSSOClientIdVisibility(item: any): void {
        item.showClientId = !item.showClientId;
    }

    // Método para alternar a visibilidade do Client Secret no SSO
    toggleSSOSecretVisibility(item: any): void {
        item.showSecret = !item.showSecret;
    }

    // Método para converter a string de scopes num array
    getScopesArray(scopes: string): string[] {
        if (!scopes) return [];
        return scopes.split(' ');
    }
}
